import { render, staticRenderFns } from "./itemSchool.vue?vue&type=template&id=daaa854a&"
import script from "./itemSchool.vue?vue&type=script&lang=js&"
export * from "./itemSchool.vue?vue&type=script&lang=js&"
import style0 from "./itemSchool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports